import { InputText } from 'primereact/inputtext';
import { classNames } from 'primereact/utils';
import { Password } from 'primereact/password';
import { useEffect, useRef, useState } from 'react';
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import { Controller, useForm } from 'react-hook-form';
import { login } from '../Services/AuthApiService';
import { useLocation, useNavigate } from 'react-router';
import { useSignIn } from '../auth/AuthService';
import { Toast } from 'primereact/toast';
        

export default function Login() {
    const containerClassName = classNames('surface-ground flex align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden');
    const navigate = useNavigate();
    const signIn = useSignIn();
    const toast = useRef(null);
    const location = useLocation();
    const [res, setRes] = useState(); 
    const defaultValues = {
        username: '',
        password: ''
    };
    const {
        control,
        formState: { errors },
        handleSubmit
    } = useForm({ defaultValues });

    const getFormErrorMessage = (name) => {
        return errors[name] ? <small className="p-error pt-1 pb-3 text-left">{errors[name].message}</small> : <small className="p-error">&nbsp;</small>;
    };

    const onSubmit = async (data) => {
        await login(data)
        .then((response) => {
            let data = response?.data;
            if (data?.status === 200 && data?.data?.accessToken) {
                if(signIn(
                    {
                        token: data?.data?.accessToken,
                        expiresIn: 60*24*7,
                        tokenType: "Bearer",
                        authState: {
                            userData: data?.data?.user, 
                            role: data?.data?.user?.role
                        }
                    }
                )) {
                    if (data?.data?.user?.role === 'user' || data?.data?.user?.role === 'secc' || data?.data?.user?.role === 'investor') {
                        navigate('/market-summary', {state: {login: true}});
                    } else if (data?.data?.user?.role === 'member_firm') {
                        navigate('/screen1');
                    }else if ( data?.data?.user?.role === 'issuer') {
                        navigate('/screen1_issuer');
                    } else if (data?.data?.user?.role === 'admin') {
                        navigate('/admin/user');
                    } else if(data?.data?.user?.role === 'manager') {
                        navigate('/admin/manager/user');
                    } else {
                        navigate('/');
                    }
                }
            }
        })
        .catch((error) => {
            let data = error?.response;
            if (data?.status === 401 ) {
                setRes(data?.data);
            }
        });
    };

    useEffect(() => {
        if (location?.state?.logout) {
            window.history.replaceState({}, document.title)
            setTimeout(() => {toast.current.show({ severity: 'info', detail:  'Logout successful!' , life: 3000 })}, 100);
        }
    }, [])

    return (
        <div className={containerClassName}>
            <div className="flex flex-column align-items-center justify-content-center">
                <div className='w-full' style={{ borderRadius: '56px', padding: '0.3rem', background: 'linear-gradient(180deg, var(--primary-color) 10%, rgba(33, 150, 243, 0) 30%)' }}>
                    <div className="w-full surface-card py-8 px-5 sm:px-8 shadow-5" style={{ borderRadius: '53px' }}>
                        <div className="text-center mb-5">
                            <img src={`/img/csx_logo.png`} alt="Image" className="mb-3" />
                            <Divider />
                            <div className="text-900 text-3xl font-medium mb-3">User Sign In</div>
                            <span className="text-600 font-medium">Sign in to continue</span>
                        </div>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className='flex flex-column w-full'>
                                <Controller
                                    name="username"
                                    control={control}
                                    rules={{ required: 'Username is required.' }}
                                    render={({ field, fieldState }) => (
                                        <>
                                            <span className="p-float-label p-input-icon-left w-full">
                                                <i className="pi pi-user" />
                                                <InputText id="username" value={field.value} className={classNames({ 'p-invalid': fieldState.error })+" w-full bg-login-card"} onChange={(e) => field.onChange(e.target.value)} />
                                                <label htmlFor="username" className="bg-login-card">Username</label>
                                            </span>
                                            {getFormErrorMessage(field.name)}
                                        </>
                                    )}
                                />
                                <Controller
                                    name="password"
                                    control={control}
                                    rules={{ required: 'Password is required.' }}
                                    render={({ field, fieldState }) => (
                                        <>
                                            <span className="p-float-label p-input-icon-left w-full">
                                                <i className="pi pi-lock z-5" />
                                                <Password className="w-full" inputClassName={classNames({ 'p-invalid': fieldState.error })+" w-full pl-6 bg-login-card"} id="password" value={field.value} onChange={(e) => field.onChange(e.target.value)} feedback={false} toggleMask/>
                                                <label htmlFor="password" className="bg-login-card">Password</label>
                                            </span>
                                            {getFormErrorMessage(field.name)}
                                        </>
                                    )}
                                />
                            </div>
                            {res?.message && <div className='text-center text-red-500 font-bold pb-3 max-w-18rem'>{res?.message}</div>}
                            <Button type="submit" label="Sign In" className="w-full p-3 text-xl" ></Button>
                        </form>
                    </div>
                </div>
            </div>
            <Toast ref={toast} />
        </div>
    );
}